import MuiHidden from "@material-ui/core/Hidden"
import PropTypes from "prop-types"

const Hidden = ({ when, ...props }) => (when ? <></> : <MuiHidden {...props} />)

Hidden.propTypes = {
  when: PropTypes.any.isRequired,
}
export default Hidden
